
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 71"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"stroke":"#BF9C5F","d":"M14.026 25.146l14.793-12.327 14.79 12.327-14.79 12.326z"}}),_c('path',{attrs:{"stroke":"#BF9C5F","d":"M12.054 35.5l17.257 13.806L46.568 35.5"}}),_c('path',{attrs:{"stroke":"#BF9C5F","d":"M12.054 45.361l17.257 13.806 17.257-13.806"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M43.61 13.806L55.935.493M47.554 0h8.875v8.875M13.914 13.183L1.206 1.479M.947 9.359L.649.812 9.193.513M43.61 57.194l12.326 13.313M47.554 71h8.875v-8.875M13.914 57.817L1.207 69.52M.947 61.642l-.299 8.546 8.545.299"}})])])
          )
        }
      }
    